import { EitherAsync } from "purify-ts";
import { CurrentSeasonDTO } from "../../service/dto/CurrentSeasonDTO";
import { seasonService } from "../../service/SeasonService";
import { SeasonInfo } from "../models/SeasonInfo";

interface IFetchCurrentSeasonUseCase {
  fetchCurrentSeason(): EitherAsync<Error, SeasonInfo | null>;
}

class FetchCurrentSeasonUseCase implements IFetchCurrentSeasonUseCase {
  fetchCurrentSeason(): EitherAsync<Error, SeasonInfo | null> {
    return EitherAsync<Error, CurrentSeasonDTO>(async () => {
      return seasonService.getCurrentSeason();
    }).map((dto) => {
      if (!dto.id) {
        return null;
      }
      return new SeasonInfo({
        id: dto.id,
        active: dto.active || false,
        seasonEnd: dto.seasonEnd || 0,
      });
    });
  }
}

export const fetchCurrentSeasonUseCase: IFetchCurrentSeasonUseCase =
  new FetchCurrentSeasonUseCase();
